import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store.tsx";
import { selectTableState } from "../api/selectTableState.ts";
import { arrangementsApi } from "../api/arrangementsApi.ts";
import { menuDataApi } from "../api/menuDataApi.ts";
import { selectActiveArrangement } from "./selectActiveArrangement.tsx";
import { ArrangementsLoadingState } from "../../../../types/qr/arrangements.ts";

export const selectArrangementLoadingState = createSelector(
  [
    (state: RootState) => state.global.salesarea.use_arrangements,
    selectTableState,
    (state) => arrangementsApi.endpoints.fetchArrangementsSettings.select()(state).data,
    (state) => arrangementsApi.endpoints.fetchArrangementsSettings.select()(state).isError,
    (state) => menuDataApi.endpoints.fetchMenuData.select()(state).data,
    (state) => menuDataApi.endpoints.fetchMenuData.select()(state).isError,
    selectActiveArrangement,
  ],
  (
    arrangements_enabled,
    tableState,
    arrangementSettings,
    arrangementSettingsIsError,
    menuData,
    menuDataIsError,
    activeArrangement
  ) => {
    if (!arrangements_enabled) return ArrangementsLoadingState.ARRANGEMENT_MODULE_INACTIVE;
    if (tableState.isError || arrangementSettingsIsError || menuDataIsError) {
      return ArrangementsLoadingState.ARRANGEMENT_FATAL_ERROR;
    }
    if (tableState.data == null || arrangementSettings == null || menuData == null)
      return ArrangementsLoadingState.LOADING;
    if (activeArrangement) return ArrangementsLoadingState.LOADED;
    return ArrangementsLoadingState.ERR_NO_ACTIVE_ARRANGEMENT;
  }
);
